import React from 'react';
import { connect } from 'react-redux';
import { DBDropDownObjective, DBTextAreaObjective, ObjectiveFlag } from '_components';
import styles from './Common.module.css'

class StrengthSitUp extends React.Component {

    render() {
        let dropdownOptions = [
            { id: 'Hands on knees', value: 'Hands on knees' },
            { id: 'Hands across chest', value: 'Hands across chest' },
            { id: 'Hands behind head', value: 'Hands behind head' },
            { id: 'Unable', value: 'Unable' }
        ];


        return (
            <div>
                <div className={styles.textfield_row}>
                    <ObjectiveFlag className={styles.flag} flagged={this.props.flagged} mopno={this.props.mopno} flagText='Strength - Sit Up' />
                    <label className={styles.label}>Sit Up</label>
                    <DBDropDownObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESTR'
                        entityKeyColumn='STNO'
                        entityKeyValue={this.props.stno}
                        field='STSITUP'
                        className={styles.situp_dropdown}
                        customOptions={dropdownOptions}
                    />
                    <span className={styles.prev_comments_wrapper}>
                        {this.props.prevVal}
                    </span>
                </div>
                <div className={styles.textarea_row}>
                    <span className={styles.flag} />
                    <label className={styles.textarea_sublabel}>Sit Up Comments</label>
                    <DBTextAreaObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESTR'
                        entityKeyColumn='STNO'
                        entityKeyValue={this.props.stno}
                        field='STSITUPCOMMENTS'
                        className={styles.textarea}
                    />
                    <span className={styles.prev_comments_wrapper}>
                        {this.props.prevComments}
                    </span>
                </div>
            </div>
        );
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let stno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVESTR)
        .find(key => (state.entities.notes.PTOBJECTIVESTR[key].STEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVESTR[key].STNTNO === pk && noteType !== 1)));

    let prevVal = '';
    let prevComments = '';

    if (noteType !== 1 && state.entities.notes.PTOBJECTIVESTRPREV[pk]) {
        prevVal = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STSITUP'];
        prevComments = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STSITUPCOMMENTS'];
    }

    return {
        noteId,
        stno,
        flagged: state.entities.notes.PTOBJECTIVESTR[stno].STSITUP ||
            state.entities.notes.PTOBJECTIVESTR[stno].STSITUPCOMMENTS
            ? true : false,
        prevVal,
        prevComments,
    };
}

const connectedStrengthSitUp = connect(mapStateToProps)(StrengthSitUp);
export { connectedStrengthSitUp as StrengthSitUp };


